import { WOW } from 'wowjs'

export default ({ app, store }, inject) => {
  const wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animate__animated',
    offset: 100,
    duration: 1,
    delay: 1,
    mobile: false,
    live: true,
  })
  inject('animate', wow)
}
